var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"emr",staticStyle:{"border":"none"},attrs:{"seamless":"","src":_vm.url,"width":"100%","height":"99%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }